import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { LinkStatusDto } from '@repo/shared/dtos/PasswordDto';
import { apiJson } from '../../utils/api-client';

export const passwordSyncQueryKeys = {
  linkStatus: () => ['passwordSync', 'linkStatus'] as const,
};

export function useLinkStatus() {
  return useQuery({
    queryKey: passwordSyncQueryKeys.linkStatus(),
    queryFn: () => apiJson<LinkStatusDto>('/api/registrants/link-status'),
    retry: 1,
  });
}

export function useLinkPassword() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (password: string) =>
      apiJson('/api/registrants/link', {
        method: 'POST',
        body: JSON.stringify({ newPassword: password }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: passwordSyncQueryKeys.linkStatus() });
    },
  });
}
